import { createMutableAction } from '@bimser/core';
import { REJECT_CONFIRMATION_MODAL } from './actionTypes';

export const onConfirmationRejectAction = (id: string) =>
	createMutableAction(REJECT_CONFIRMATION_MODAL, id);
